// Interfaces
import { TBreakpointSystem } from '../interfaces/system.interface';

export class ScreenConfig {
  static breakpoints: any = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1440
  };

  static mobile:  TBreakpointSystem[] = ['xs'];
  static tablet:  TBreakpointSystem[] = ['sm'];
  static desktop: TBreakpointSystem[] = ['md', 'lg'];
  static fullHD:  TBreakpointSystem[] = ['xl', 'xxl'];
}
